/**
 * @deprecated This component is no longer in use as of December 2025.
 * The sidebar navigation has been removed in favor of direct navigation through the profile page.
 * This file is kept for reference only and may be removed in future versions.
 */

import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UserService } from 'src/infrastructure/adapters/services/user.service';
import { AddressStateService } from 'src/infrastructure/adapters/services/address-state.service';
import { LogoStateService, LogoState } from 'src/infrastructure/adapters/services/logo-state.service';
import { ManagementCompany } from 'src/core/interfaces/ports/Outputs/commune';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class SideBarComponent implements OnInit {
  logoState: LogoState = {
    communeLogo: null,
    companyLogo: null,
    managementCompany: null
  };
  
  // Default fallback logos
  readonly defaultCompanyLogoDark = 'assets/images/logos/starco_white.png';
  readonly defaultCompanyLogoStarco = 'assets/images/logos/starco_white.png';
  readonly defaultCompanyLogoDemarco = 'assets/images/logos/demarco_black.png';

  constructor(
    private navCtrl: NavController,
    private userService: UserService,
    private addressStateService: AddressStateService,
    private logoStateService: LogoStateService
  ) { }

  ngOnInit() {
    // Subscribe to logo state changes
    this.logoStateService.logoState$.subscribe(state => {
      this.logoState = state;
    });
  }

  get companyLogoUrl(): string {
    // Use white version of logos for sidebar
    if (this.logoState.managementCompany === ManagementCompany.DEMARCO) {
      return this.defaultCompanyLogoDemarco;
    } else if (this.logoState.managementCompany === ManagementCompany.STARCO) {
      return this.defaultCompanyLogoStarco;
    }
    return this.defaultCompanyLogoDark;
  }

  closeSidebar() {
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      sidebar.classList.remove('open'); // Remove the open class to close the sidebar
      setTimeout(() => {
        sidebar.style.display = 'none'; // Hide the sidebar after the animation
      }, 300); // Match the duration of the CSS transition
    }
  }

  navigateTo(page: string) {
    // Use navigateRoot to prevent page stacking from menu
    this.navCtrl.navigateRoot(`/${page}`);
    this.closeSidebar();
  }

  async logout() {
    this.closeSidebar();
    
    this.addressStateService.refreshAddressForAuthState();
    

    await this.userService.logout();
  }
}